/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_ErrorInputs */

const en_apartment_error = /** @type {(inputs: Apartment_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't load this apartment. Please try again.`)
};

/**
* | output |
* | --- |
* | "We couldn't load this apartment. Please try again." |
*
* @param {Apartment_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_error = /** @type {((inputs?: Apartment_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_error(inputs)
});